import React from 'react';
import parse from 'html-react-parser';
import Image from '../image/Image';
import { sharedIconsPath } from '../../scripts/data';
import { ISpotCard } from '../../interfaces';
import SpotIconCards from '../card-groups/SpotIconCards';

interface Props {
  config: IReturnUserFullConfig;
  userName?: string | null | undefined;
}

export interface IReturnUserFullConfig {
  subHeadingCol1: React.ReactNode | string;
  btnTextCol1: string;
  btnLinkCol1: string;
  headingCol2: React.ReactNode | string;
  subHeadingCol2?: React.ReactNode | string;
  btnTextCol2: string;
  btnLinkCol2: string;
  btnLink2Col1: string;
  mqeBottomSection?: React.ReactNode;
  spotIconCards: ISpotCard[];
  bottomDisclosures?: React.ReactNode;
}

const ReturnUserFull = ({ config, userName }: Props) => {
  // prevent SSR render
  if (typeof window === 'undefined') return null;

  // Return user UI
  return (
    <>
      <section
        className="z-0 position-relative"
        id="mqe-box-wrapper">
        <div
          className="mqe-box-bg"
          style={{ height: '82%' }}
        />
        <div className="container container-sm-py pb-0">
          <div className="row justify-content-center">
            <div
              className="col-xl-10 bg-white p-md-4 p-lg-7 z-1 position-relative"
              id="mqe-box">
              <div className="row justify-content-md-between gx-md-5 gx-lg-7">
                <div className="col-md-6 mb-6 mb-md-0">
                  <h1 className="h3">{`Welcome back${userName ? `, ${userName}` : ''}`}</h1>
                  <p className="text-gray h5 mb-5">
                    {typeof config.subHeadingCol1 === 'string'
                      ? parse(config.subHeadingCol1)
                      : config.subHeadingCol1}
                  </p>
                  <a
                    className="btn btn-primary w-100"
                    data-op="LGM"
                    href={config.btnLinkCol1}>
                    {config.btnTextCol1}
                  </a>
                  <p className="body-text-sm mt-3 mb-0">
                    <strong>{`Not ${userName ? userName : 'a member'}?`}</strong>&nbsp;
                    <a
                      data-op="MQE"
                      href={config.btnLink2Col1}>
                      Sign up for free
                    </a>
                  </p>
                </div>
                <div className="col-md-6">
                  <div className="bg-purple dark-theme-two-squircles-pattern border rounded p-3 p-lg-4 d-flex text-white">
                    <Image
                      alt="Icon what is new."
                      className="spot-icon-md me-3 shake"
                      height="56"
                      src={`${sharedIconsPath}/icon-what-is-new.svg`}
                      width="56"
                    />
                    <div>
                      <h2 className={`h5 ${config.subHeadingCol2 ? '' : 'mb-0'}`}>
                        {typeof config.headingCol2 === 'string'
                          ? parse(config.headingCol2)
                          : config.headingCol2}
                      </h2>

                      {config.subHeadingCol2 && (
                        <p className="body-text-sm mb-0">
                          {typeof config.subHeadingCol2 === 'string'
                            ? parse(config.subHeadingCol2)
                            : config.subHeadingCol2}
                        </p>
                      )}
                      <a
                        className="btn btn-outline-white btn-min-width mt-5"
                        data-op="QAC"
                        href={config.btnLinkCol2}>
                        {config.btnTextCol2}
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              {config.mqeBottomSection || null}
            </div>
          </div>
        </div>
      </section>

      <section className="container container-py">
        <h2 className="content-mb text-lg-center">Quick actions</h2>

        <SpotIconCards
          cards={config.spotIconCards}
          cardsPerPage={2}
        />

        {config.bottomDisclosures || null}
      </section>
    </>
  );
};

export default ReturnUserFull;
